<template>
  <div class="price-bar">
    <div class="price-bar__price-wrap" v-if="price">
      <product-price
        :old-price="oldPrice"
        :price="price"
        vertical
        size="small"
      ></product-price>
    </div>
    <div v-if="productId" class="price-bar__actions">
      <add-to-comparison-btn
        title-ru=""
        :product-id="productId"
      ></add-to-comparison-btn>
      <wish-list-btn
        :id="productId"
        :price="price"
        :code="code"
        :is-in-stock="inStock || Object.keys(availableInStore).length > 0"
        :in-wish-list-status="inWishListStatus"
        :analytics-data="analyticsData"
      ></wish-list-btn>
    </div>
    <div class="price-bar__btns">
      <buy-btn
        v-if="isPreorder && !isArchive"
        pre-order-btn
        size="medium"
        :title-ru="titleRu"
        :product-id="productId"
        :code="code"
        :price="price"
        class="product-actions__btn product-actions__btn--pre-order"
      ></buy-btn>
      <buy-btn
        v-else-if="price && (inStock || availableInStore)"
        size="medium"
        :price="price"
        :code="code"
        :title-ru="titleRu"
        :product-id="productId"
        :store-id="availableInStore ? availableInStore.store_id : ''"
        class="product-actions__btn product-actions__btn--buy"
      ></buy-btn>
      <wait-list-btn
        v-else
        :in-wait-list-status="isInWaitList"
        :product-id="productId"
        class="product-actions__btn product-actions__btn--wait-list"
      ></wait-list-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import ProductPrice from '@/components/product/ProductPrice.vue'
import AddToComparisonBtn from '@/components/product/product-comparison/AddToComparisonBtn.vue'
import WishListBtn from '@/components/product/WishListBtn.vue'
import BuyBtn from '@/components/cart/BuyBtn.vue'
import WaitListBtn from '@/components/product/product-page/WaitListBtn.vue'

export default {
  name: 'PriceBottomBar',
  components: {
    WaitListBtn,
    BuyBtn,
    WishListBtn,
    ProductPrice,
    AddToComparisonBtn
  },
  computed: {
    ...mapState({
      price: state => state.productInfo.productInfo.price,
      oldPrice: state => state.productInfo.productInfo.oldPrice,
      productId: state => state.productInfo.productInfo.productId,
      code: state => state.productInfo.productInfo.code,
      inStock: state => state.productInfo.productInfo.inStock,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      inWishListStatus: state => state.productInfo.productInfo.inWishListStatus,
      titleRu: state => state.productInfo.productInfo.titleRu,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isInWaitList: state => state.productInfo.productInfo.isInWaitList,
      isArchive: state => state.productInfo.productInfo.isArchive
    })
  },
  filters: {
    CurrencyFormatter
  },
  props: {
    analyticsData: {
      type: Array
    }
  }
}
</script>

<style lang="sass" scoped>
.price-bar
  display: flex
  position: fixed
  left: 0
  bottom: 63px
  border-bottom: 1px solid #e7e7e7
  width: 100%
  background-color: #fff
  border-top: 1px solid #E7E7E7
  padding: 7px 15px
  border-top-left-radius: 3px
  border-top-right-radius: 3px
  box-shadow: 0 -1px 1px 0px rgba(0, 0, 0, 0.05)
  justify-content: space-between
  max-width: 100vw
  z-index: 4
  +mmin($tablet)
    display: none
  &__price-wrap
    margin-right: 7px
    display: flex
    align-items: center
    justify-content: center
  &__actions
    display: flex
    align-items: center
    margin-right: 0
    margin-left: auto
    width: 16%
    justify-content: space-between
    min-width: 86px
    +mmin($small)
      margin-right: 6vw
</style>
<style lang="sass">
.price-bar
  &__btns
    margin-left: 7px
    .buy-btn
      font-size: 16px !important
      padding-top: 11px !important
      padding-bottom: 11px !important
      height: 44px !important
      padding-left: 22px !important
      padding-right: 22px !important
  .wait-list__btn
    padding: 5px 15px
    font-size: 14px
    font-weight: 500
    color: #333
    min-width: 150px
    +mmax(375)
      padding: 2px 3px
      height: 44px
      min-width: 107px
    svg
      display: none
  .wait-list__response
    display: none
  .buy-btn.buy-btn--pre-order
    padding: 11px 10px
    +mmax(375)
      padding: 2px 3px
      height: 44px
      min-width: 100px
      justify-content: center
  .product-price--small .product-price__current
    font-size: 20px
    line-height: 24px
    +mmax(375)
      font-size: 18px
      line-height: 22px
  .product-price--small .product-price__old
    +mmax(375)
      font-size: 12px
      line-height: 15px
  .add-to-comparison, .wish-list-btn
    height: 100%
    width: 43px
  .wish-list-btn__svg
    width: 24px
    height: 24px
  .add-to-cart__svg-wrap
    display: none
  .bonus-info
    margin: 1px 0 0 0
    &__icon
      width: 18px
      height: 18px
      margin-right: 5px
    &__text
      margin: 0
    &__text-contrast
      margin: 0
      font-size: 14px
      line-height: 17px
      color: rgba(#333333, 0.8)
      +mmax(375)
        font-size: 12px
        line-height: 15px
</style>
